import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { demoModel, demoOptionsFrom } from "./app/demo/demo";

const root = createRoot(document.getElementById("root")!);
const params = new URLSearchParams(location.search);
const theme = params.get("theme");
if (theme === "dark" || theme === "light") document.documentElement.dataset.theme = theme;

// A build for showing (VITE_DEMO=1) is always the demo.
if (params.has("demo") || import.meta.env.VITE_DEMO === "1") {
  // The demo account: the real Store on a server in memory, no Firebase (and what the Playwright tests use).
  const model = demoModel(demoOptionsFrom(location.search));
  root.render(<StrictMode><App model={model} /></StrictMode>);
} else {
  // The real account: Firebase Auth, the store and its sync (src/data/session.ts).
  void import("./app/LiveApp").then(({ LiveApp }) => root.render(<StrictMode><LiveApp /></StrictMode>));
}
